// extracted by mini-css-extract-plugin
module.exports = {"paper":"CarchupaPaper_paper__N2zB8","content":"CarchupaPaper_content__3fM2R"};